import Heart from "../../../assets/images/heart.svg";
import HeartEmpty from "../../../assets/images/heart-empty.svg";

import * as S from "../styles";

const MAX = 3;

const HeartBar = ({ health, hurting }) => {
  const safe = Math.max(0, Math.min(MAX, health));
  return (
    <S.Health className={hurting ? "hurt" : ""}>
      {Array.from({ length: MAX }).map((_, i) => (
        <img
          key={i}
          src={i < safe ? Heart : HeartEmpty}
          alt={i < safe ? "heart-full" : "heart-empty"}
        />
      ))}
    </S.Health>
  );
};

export default HeartBar;
